/**
 * assets/ssuk-collection.js                               SSUK, 20 Sept 2026
 *
 * Adds the "See more" control to the collection intro copy.
 *
 * The collapsing itself is CSS and mobile-only; this file only adds the
 * button and flips one class, so:
 *   - desktop is untouched, and the button never renders there
 *   - the copy is clamped by default, so there is no flash of the full
 *     paragraph before this script runs
 *   - every word and internal link stays in the DOM for crawlers
 *
 * Done in JS rather than Liquid because the banner lives in
 * collection-landing.liquid, 1,800 lines, and a control is not content.
 */
(function () {
  'use strict';

  function build(intro) {
    if (intro.querySelector('.ssuk-intro-more')) return;
    if (!intro.textContent.trim()) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ssuk-intro-more';
    btn.setAttribute('aria-expanded', 'false');

    var text = document.createElement('span');
    text.className = 'ssuk-intro-more__text';
    text.textContent = 'See more';

    var chev = document.createElement('span');
    chev.className = 'ssuk-intro-more__chev';
    chev.setAttribute('aria-hidden', 'true');

    btn.appendChild(text);
    btn.appendChild(chev);

    btn.addEventListener('click', function () {
      var open = intro.classList.toggle('ssuk-intro--open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      text.textContent = open ? 'See less' : 'See more';
    });

    /* After the copy, not inside it: the clamp applies to the intro's own
       children, and the button must not be one of the clamped lines. */
    intro.parentNode.insertBefore(btn, intro.nextSibling);
  }

  function init() {
    var intros = document.querySelectorAll('.topdescription');
    for (var i = 0; i < intros.length; i++) build(intros[i]);
  }

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
